export const showPopup = (id: string, data?: any) => {
  let event = new CustomEvent('popup_open', { detail: id });

  // @ts-ignore
  if (data) event.data = data;
  window.dispatchEvent(event);
};
